<template>
  <div id="pIndex">
    <Nav />
    <!-- <div style="height: 2000px;"></div> -->
    <div class="index-banner">
      <div class="top-container">
        <div class="swiper-wrapper">
          <!-- <div
            class="swiper-slide"
            :style="{background: `url(${require(`@/assets/pIndex-t-slide5.jpg`)}) center/cover no-repeat`}"
          >
            <router-link to="/ProjectDetail/3/304">
              <div class="slide-word">
                <p class="c333">Rich More瑜伽牵引</p>
                <p class="c333">全身肌肉放松释放疲劳</p>
                <p class="blockBtn">了解详情</p>
              </div>
            </router-link>
          </div> -->
          <div
            class="swiper-slide"
            :style="{background: `url(${require(`@/assets/pIndex-t-slide4.jpg`)}) center/cover no-repeat`}"
          >
            <router-link to="/ProjectDetail/1/109">
              <div class="slide-word">
                <p class="c333">P.01抗糖化温感8合1石膏护理</p>
                <p class="c333">高效嫩肤，抗衰抗糖</p>
                <p class="blockBtn">了解详情</p>
              </div>
            </router-link>
          </div>
          <div
            class="swiper-slide"
            :style="{background: `url(${require(`@/assets/pIndex-t-slide1.jpg`)}) center/cover no-repeat`}"
          >
            <router-link to="/Project/1">
              <div class="slide-word">
                <p>您可以放松身心，享受幸福的时光</p>
                <p>凝聚FK的智慧和优雅</p>
                <p class="blockBtn">探索皮肤管理</p>
              </div>
            </router-link>
          </div>
          <div
            class="swiper-slide"
            :style="{background: `url(${require(`@/assets/pIndex-t-slide2.jpg`)}) center/cover no-repeat`}"
          >
            <router-link to="/Project/2">
              <div class="slide-word">
                <p>日式传统技艺与科技的结合，改变头皮衰老</p>
                <p>瞬间进入梦乡的温泉护理</p>
                <p class="blockBtn">探索头皮管理</p>
              </div>
            </router-link>
          </div>
          <div
            class="swiper-slide"
            :style="{background: `url(${require(`@/assets/pIndex-t-slide3.jpg`)}) center/cover no-repeat`}"
          >
            <router-link to="/ProjectDetail/1/101">
              <div class="slide-word">
                <p>一颗焕颜的“灯泡”裸肌</p>
                <p>专注肌肤逆龄</p>
                <p class="blockBtn">探索以色列黑科技</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="top-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class style="height: 290px;">
      <div class="pContent" style="padding-top: 90px;">
        <div class="blockTit" style="margin-top: 0px;">项目信息</div>
        <div class="blockText" style="margin-top: 30px;">
          通过引进自日本、德国、西班牙、以色列...的国际先进设备，
        </div>
        <div class="blockText" style>
          构建涵盖皮肤、头皮、身体的综合美态管理体系，为您提供完整的美丽方案。
        </div>
      </div>
    </div>
    <div class="index-banner pContent">
      <div class="mid-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/2/204">
              <img src="../assets/pIndex-m-slide1.jpg" alt />
            </router-link>
            <p>综合改善头皮老化</p>
          </div>
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/1/106">
              <img src="../assets/pIndex-m-slide2.jpg" alt />
            </router-link>
            <p>面部抗老提升</p>
          </div>
          <div class="swiper-slide">
            <router-link to="/ProjectDetail/3/301">
              <img src="../assets/pIndex-m-slide3.jpg" alt />
            </router-link>
            <p>INDIBA身体细胞平衡疗法</p>
          </div>
        </div>
        <div class="mid-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div style="height: 450px; background: #f8f9f8;">
      <div class="pContent" style="padding-top: 104px;">
        <div class="blockTit" style="margin-top: 0;">会员服务</div>
        <div class="blockText" style="margin-top: 30px;">
          我们为会员提供广泛的服务，
        </div>
        <div class="blockText">请享受成为会员所持有的优惠。</div>
        <router-link to="/Member" class="blockBtn">立即探索</router-link>
      </div>
    </div>
    <div>
      <div
        class="pIndex-shop pContent"
        style="padding-top: 115px; height: 450px;"
      >
        <div class="blockTit" style="margin-top: 0; color: #fff;">
          查找离您最近的精品店
        </div>
        <div class="blockText" style="margin-top: 30px; color: #fff;">
          您目前所处的位置？
        </div>
        <router-link to="/Shop" class="blockBtn shop" style="margin-top: 70px;"
          >获取路线</router-link
        >
      </div>
    </div>
    <div class style="padding-top: 90px; height: 290px;">
      <div class="blockTit" style="margin-top: 0;">关于沙龙</div>
      <div class="blockText" style="margin-top: 30px;">
        FK引领着国内依托先进科技进行各项美态管理的新概念，
      </div>
      <div class="blockText">致力于让美业更有科技。</div>
    </div>
    <div class="pContent pIndex-about flexBox horizontal">
      <router-link to="/About/history" class="item">
        <div class="imgBox">
          <img src="../assets/pIndex-about1.jpg" alt />
        </div>
        <p>FK发展史</p>
      </router-link>
      <router-link to="/About/star" class="item">
        <div class="imgBox">
          <img src="../assets/pIndex-about2.jpg" alt />
        </div>
        <p>明星会员</p>
      </router-link>
      <router-link to="/About/brand" class="item">
        <div class="imgBox">
          <img src="../assets/pIndex-about3.jpg" alt />
        </div>
        <p>品牌合作</p>
      </router-link>
    </div>
    <div class="pContent" style="padding-bottom: 80px; height: 270px;">
      <div class="blockTit" style="font-size: 20px;">SHARE</div>
      <div class="pIndex-share">
        <i class="pIndex-ins" @click="shareIns = true"
          >FOLLOW US ON INSTAGRAM</i
        >
        <i class="pIndex-wx" @click="shareWx = true">FOLLOW US ON WECHAT</i>
      </div>
    </div>
    <mu-dialog title class="fullImg" width="636" :open.sync="shareIns">
      <i class="close" @click="shareIns = false"></i>
      <div class="item">
        <div class="d-title">
          欢迎关注FK，
          <br />了解更多详情
        </div>
        <img src="../assets/pIndex-dialog-ins.png" alt />
      </div>
    </mu-dialog>
    <mu-dialog title class="fullImg" width="636" :open.sync="shareWx">
      <i class="close" @click="shareWx = false"></i>
      <div class="item">
        <div class="d-title wx">
          欢迎添加微信，
          <br />了解更多详情
        </div>
        <img src="../assets/pIndex-dialog-wx.png" alt />
      </div>
    </mu-dialog>

    <ToTop />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import ToTop from "@/components/ToTop.vue";

export default {
  name: "pIndex",
  data() {
    return {
      shareIns: false,
      shareWx: false,
    };
  },
  components: {
    Nav,
    ToTop,
  },
  computed: {},
  methods: {
    initBanner() {
      require("../assets/pIndex-t-slide1.jpg");
      require("../assets/pIndex-t-slide2.jpg");
      require("../assets/pIndex-t-slide3.jpg");
      let banner = new Swiper(".top-container", {
        // effect: 'fade',
        loop: true,
        // initialSlide: 2,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".top-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
      });
      // banner.slideNext();
    },
    initMswiper() {
      new Swiper(".mid-container", {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".mid-pagination",
          clickable: true,
        },
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.initBanner();
      this.initMswiper();
    }, 200);
  },
};
</script>

<style lang="scss">
#pIndex {
  padding-bottom: 40px;

  .pContent {
    margin: 0 auto;
    width: 90%;
    max-width: 1200px;
  }
  .blockTit {
    margin: 90px auto 0;
    font-weight: 200;
    font-size: 40px;
    line-height: 1;
  }
  .blockText {
    font-weight: 200;
    font-size: 16px;
    line-height: 28px;
  }
  .index-banner {
    position: relative;
    overflow: hidden;
  }
  .top-container {
    height: 600px;

    .swiper-slide > a {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .swiper-button-prev,
    .swiper-button-next {
      top: 280px !important;
    }

    .slide-word {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -55px;
      margin-left: -406px;

      p:nth-child(1) {
        font-size: 24px;
        font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 33px;
      }
      p:nth-child(2) {
        font-size: 38px;
        line-height: 68px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      p:nth-child(3) {
        margin-left: 0;
        margin-top: 28px;
        cursor: pointer;
      }
    }
  }

  .top-pagination {
    bottom: 32px !important;
  }
  .mid-container,
  .bottom-container {
    padding-bottom: 70px;
    .swiper-slide {
      // width: 540px;
      img {
        display: block;
      }
      p {
        margin-top: 32px;
        font-size: 16px;
        line-height: 28px;
        color: #555;
        text-align: center;
      }
    }
  }

  #pIndex .mu-dialog {
    max-width: none !important;
    .mu-dialog-body {
      padding: 0;
      > img {
        display: block;
        width: 100%;
      }
    }
  }
  .blockBtn {
    margin-top: 56px;
    width: 282px;
    height: 58px;
    font-size: 16px;
    line-height: 56px;
    border: 1px solid transparent;
    transition: all 1s;
    &:hover {
      background: rgba(246, 246, 246, 1);
      border-color: #d6caab;
    }

    &.shop {
      background: rgba(246, 246, 246, 1);
      border-color: transparent;
    }
    &.shop:hover {
      background: #d6caab;
      border-color: transparent;
    }
  }
  .pIndex-shop {
    background: url(../assets/pIndex-shop.jpg) top/auto 100% no-repeat;
  }
  .pIndex-about {
    .item {
      flex: 1;
      margin: 0 8px;
      text-align: center;

      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .imgBox {
        position: relative;
        img {
          display: block;
          width: 100%;
        }
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(60, 46, 30, 0.15);
          opacity: 0;
          transition: all 0.5s;
        }
        &:hover::after {
          opacity: 1;
        }
      }

      p {
        position: relative;
        display: inline-block;
        margin-top: 32px;
        font-size: 16px;
        line-height: 22px;
        color: #313131;
        text-align: center;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -14px;
          width: 100%;
          height: 1px;
          background: #333;
          opacity: 0;
          transform: scale(0.4);
          transition: all 0.5s;
        }
      }

      &:hover p::after {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  .pIndex-share {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 70px;
    > i {
      position: relative;
      display: inline-block;
      margin: 0 30px;
      // padding-left: 95px;
      width: 380px;
      height: 60px;
      font-style: normal;
      font-weight: 200;
      font-size: 16px;
      line-height: 60px;
      text-indent: 5em;
      background: url(../assets/pIndex-ins.png) left/100% no-repeat transparent;
      border: 1px solid #000;
      cursor: pointer;
      transition: all 0.5s;

      &.pIndex-wx {
        background-image: url(../assets/pIndex-wx.png);
      }

      &:hover {
        background-color: #d6caab;
        border-color: #d6caab;
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      @media (max-width: 768px) {
        margin: 0 10px;
        text-indent: 4.5em;
      }
    }
  }
  .index-banner .swiper-button-next,
  .index-banner .swiper-button-prev {
    top: 200px;
    width: 49px;
    height: 49px;
    background: none;
    transition: all 0.2s;
    outline: 0;
    opacity: 0;
    transform: translateX(50px);
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/pIndex-next.png) no-repeat;
      transition: all 0.3s;
    }
    &:hover::after {
      transform: scale(1.1);
    }
  }
  .index-banner .swiper-button-prev {
    transform: translateX(-50px);
    &::after {
      background: url(../assets/pIndex-prev.png) no-repeat;
    }
  }
  // .swiper-wrapper:hover ~ .swiper-button-next,
  // .swiper-wrapper:hover ~ .swiper-button-prev {
  //     transform: translateX(0);
  //     opacity: 1;
  // }
  .index-banner:hover .swiper-button-next,
  .index-banner:hover .swiper-button-prev {
    transform: translateX(0);
    opacity: 1;
  }

  .top-pagination {
    span {
      position: relative;

      &::after {
        content: "";
        // float: left;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #818181;
        transform: scaleX(0);
        transform-origin: left;
      }
      &.swiper-pagination-bullet-active {
        background: #e1dede !important;
        &::after {
          animation: active 5s linear forwards;
        }
      }
    }
  }
}
@keyframes active {
  to {
    transform: scaleX(1);
    // width: 100%;
  }
}
.fullImg {
  .mu-dialog {
    max-width: none;
  }
  .mu-dialog-body {
    position: relative;
    padding: 50px;
    height: 516px;
    > img {
      display: block;
      margin: 0 auto;
      width: auto;
    }
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;
    height: 50px;
    cursor: pointer;
    &::after,
    &::before {
      content: "";
      position: absolute;
      left: 15px;
      top: 50%;
      margin-top: -1px;
      width: 20px;
      height: 2px;
      background: #000;
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }
  }

  .item {
    margin: 0 auto;
    width: 320px;

    .d-title {
      margin: 0 auto;
      padding-left: 54px;
      width: 160px;
      font-size: 14px;
      line-height: 20px;

      background: url(../assets/dialog-ins.png) left/40px no-repeat;
      &.wx {
        background-image: url(../assets/dialog-wx.png);
      }
    }
    > img {
      display: block;
      margin: 47px auto 0;
      padding: 12px;
      width: 260px;
      height: 260px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 21px;
    }
  }
}
</style>
